import request from '@/utils/request'

/**
 * 余额查询
 * @param {*} productId 产品ID 
 * @returns 
 */
export function getSpecialBalance(productId) {
    return request.post("/product/special/balance/get", { productId: productId })
}

/**
 * 订单创建
 * @param {*} order 
 * @returns 
 */
export function specialCreateOrder(order) {
    return request.post("/product/special/order/create", order)
}

/**
 * 协议签署
 * @param {*} order 
 * @returns 
 */
export function specialProtocolSign(order) {
    return request.post("/product/special/protocol/sign", order)
}

/**
 * 余额支付（确认）
 * @param {*} from 
 * @returns 
 */
export function specialBalancePay(from) {
    return request.post("/product/special/balance/pay", from)
}